import state from "./segmentState";
import mutations from "./segmentMutations";
import getters from "./segmentGetters";
import actions from "./segmentActions";
import metadataFilterActions from "./metadataFilterActions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {
    ...actions,
    ...metadataFilterActions
  }
};
